/**
 * Validates a `redirect` query param so it can only point to a relative,
 * same-site path — never an absolute URL or protocol-relative "//host" path.
 * Prevents an open-redirect if someone crafts a link like
 * /login?redirect=https://evil.example.com.
 */
export const getSafeRedirectPath = (searchParams, fallback = '/dashboard') => {
    const redirect = searchParams.get('redirect');
    if (redirect && redirect.startsWith('/') && !redirect.startsWith('//')) {
        return redirect;
    }
    return fallback;
};

/** Current page's path + query string, for building a `?redirect=` target. */
export const currentPagePath = () => window.location.pathname + window.location.search;
